import Cookies from 'js-cookie';
import pick from 'object.pick';
import BaseStore from './baseStore';
import {
  FLOW_INPUT_COMPLETED,
  INPUT_VALIDATION_FAILED,
  INPUT_CHANGED,
  INPUT_REGISTRATION_COMPLETED
} from 'src/config/actions';
import userConfig from 'src/config/userConfig';

class RegistrationStore extends BaseStore {
  constructor() {
    super();
    this.user = {
      terms_and_conditions: true,
      privacy_policy: true
    };
    this.registrationOptions = { immediate_verification_email_advised: true };
    this.error = {};

    this.loadUserLocalData();
  }

  getUserData() {
    return Object.assign({}, this.user);
  }

  getRegistrationOptions() {
    return Object.assign({}, this.registrationOptions);
  }

  getUserErrors() {
    return Object.assign({}, this.error);
  }

  loadUserLocalData() {
    userConfig.WHITELISTED_USER_DATA.forEach((data) => {
      this.user[data] = Cookies.get(data);
    });
  }

  setUserLocalData(userData) {
    const relevantData = pick(userData, userConfig.WHITELISTED_USER_DATA);

    Object.entries(relevantData).forEach(([key, value]) => {
      return Cookies.set(key, value);
    });
  }

  removeUserLocalData(userData) {
    const relevantData = pick(userData, userConfig.WHITELISTED_USER_DATA);

    Object.keys(relevantData).forEach((key) => {
      return Cookies.remove(key);
    });
  }

  onDispatcherAction({ type, data }) {
    switch (type) {
      case FLOW_INPUT_COMPLETED:
        this.user = data.user;
        this.error = {};
        break;

      case INPUT_VALIDATION_FAILED:
        this.error = data.error;
        this.user = data.user;
        this.emitChange();
        break;

      case INPUT_CHANGED:
        this.setUserLocalData(data);
        break;

      case INPUT_REGISTRATION_COMPLETED:
        this.removeUserLocalData(this.user);
        break;
      // no default
    }
  }
}

export default new RegistrationStore();
